class AnnouncementBarInfiniteScroll {
    constructor() {
        this.carousel = document.querySelector('.ctn_announcement_bar.carousel');
        this.track = document.querySelector('.carousel-track');
        this.originalGroup = null;
        this.isStaticMode = false;
        
        if (!this.carousel || !this.track) return;
        
        this.isStaticMode = this.track.classList.contains('static');
        if (this.isStaticMode) return;
        
        this.init();
    }
    
    init() {
        this.originalGroup = this.track.querySelector('.group');
        if (!this.originalGroup) return;
        
        this.createDynamicCopies();
        
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            if (resizeTimer !== null) {
                clearTimeout(resizeTimer);
            }
            resizeTimer = setTimeout(() => {
                this.createDynamicCopies();
            }, 250);
        });
    }
    
    createDynamicCopies() {
        if (!this.track) return;
        
        const firstGroup = this.track.querySelector('.group');
        if (!firstGroup) return;
        
        this.track.innerHTML = '';
        this.track.appendChild(firstGroup);
        
        const viewportWidth = window.innerWidth;
        const groupWidth = firstGroup.offsetWidth;
        
        if (groupWidth <= 0 || groupWidth === undefined || groupWidth === null) {
            console.warn('Announcement bar is hidden (offsetWidth = 0), skipping cloning to prevent infinite loop');
            return;
        }
        
        const minRequiredWidth = viewportWidth * 3;
        const copiesNeeded = Math.ceil(minRequiredWidth / groupWidth);
        
        const totalCopies = Math.max(copiesNeeded, 4);
        
        for (let i = 1; i < totalCopies; i++) {
            const clone = firstGroup.cloneNode(true);
            if (clone instanceof HTMLElement) {
                clone.setAttribute('aria-hidden', 'true');
                this.track.appendChild(clone);
            }
        }
        
        this.updateAnimation(totalCopies);
    }
    
    updateAnimation(totalCopies) {
        const movePercentage = -(100 / totalCopies);
        
        let styleTag = document.getElementById('announcement-bar-animation');
        if (!styleTag) {
            styleTag = document.createElement('style');
            styleTag.id = 'announcement-bar-animation';
            document.head.appendChild(styleTag);
        }
        
        styleTag.textContent = `
            @keyframes scrolling-dynamic {
                0% {
                    transform: translateX(0);
                }
                100% {
                    transform: translateX(${movePercentage}%);
                }
            }
            
            .carousel-track {
                animation-name: scrolling-dynamic !important;
            }
        `;
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new AnnouncementBarInfiniteScroll();
    });
} else {
    new AnnouncementBarInfiniteScroll();
}
